<script>
import { chartingOhlcGeometry, CHARTING_OHLC_COLORS } from '../services/chartingOhlcSeries';
import { formatNumberLabel } from '../adapters/chartingAdapterUtils';

export default {
    name: 'ChartingEngulfingPlot',
    props: { candidate: { type: Object, required: true }, detail: { type: Object, required: true } },
    computed: {
        plot() {
            const weeks = this.detail.weeks;
            const bars = [this.candidate.previous, ...weeks];
            const low = Math.min(...bars.map(bar => bar.low));
            const high = Math.max(...bars.map(bar => bar.high));
            const min = Math.log(low), range = Math.max(0.001, Math.log(high) - min);
            const y = price => 206 - (Math.log(price) - min) / range * 166;
            const x = index => index === 0 ? 42 : 122 + (index - 1) * 260 / Math.max(1, weeks.length - 1);
            return {
                guideY: y(this.candidate.previous.low),
                ticks: [0, 1, 2, 3].map(index => { const price = Math.exp(min + range * index / 3); return { y: y(price), label: formatNumberLabel(price) }; }),
                bars: bars.map((bar, index) => ({
                    x: x(index), color: index === 0 ? '#94a3b8' : bar.close >= bar.open ? CHARTING_OHLC_COLORS.upColor : CHARTING_OHLC_COLORS.downColor,
                    label: index === 0 ? 'Mes anterior' : `${new Date(bar.firstSession * 1000).getUTCDate()}${bar.firstSession === bar.lastSession ? '' : `–${new Date(bar.lastSession * 1000).getUTCDate()}`}${bar.partial ? '*' : ''}`,
                    description: index === 0 ? 'Mes anterior' : `Semana ${bar.label}${bar.partial ? ', solo sesiones del mes' : ''}`,
                    rectangles: chartingOhlcGeometry({ x: x(index), highY: y(bar.high), lowY: y(bar.low), openY: y(bar.open), closeY: y(bar.close) }, 32, 1, 1)
                })),
                events: this.detail.events.map((event, index) => ({ ...event, number: index + 1,
                    x: x(1 + weeks.findIndex(week => event.time >= week.firstSession && event.time <= week.lastSession)) + 15, y: y(event.price) }))
            };
        }
    }
};
</script>

<template>
    <svg class="charting-engulfing-plot" viewBox="0 0 450 250" role="img" :aria-label="'Desglose semanal de ' + candidate.monthLabel + ', junto al mes anterior. Escala logarítmica.'">
        <rect x="86" y="9" width="318" height="226" rx="12" class="charting-engulfing-plot__month" />
        <text x="100" y="25" class="charting-engulfing-plot__caption">MES DESPLEGADO EN SEMANAS</text>
        <g v-for="(tick, index) in plot.ticks" :key="'tick-' + index">
            <line x1="14" x2="406" :y1="tick.y" :y2="tick.y" class="charting-engulfing-plot__grid" />
            <text x="447" :y="tick.y + 3" text-anchor="end" class="charting-engulfing-plot__price">{{ tick.label }}</text>
        </g>
        <line x1="14" x2="402" :y1="plot.guideY" :y2="plot.guideY" class="charting-engulfing-plot__guide" />
        <g v-for="(bar, index) in plot.bars" :key="'bar-' + index">
            <title>{{ bar.description }}</title>
            <rect v-for="(rect, rectIndex) in bar.rectangles" :key="rectIndex" v-bind="rect" :fill="bar.color" />
            <text :x="bar.x" y="229" text-anchor="middle" class="charting-engulfing-plot__price">{{ bar.label }}</text>
        </g>
        <g v-for="event in plot.events" :key="event.number">
            <circle :cx="event.x" :cy="event.y" r="8" class="charting-engulfing-plot__event" />
            <text :x="event.x" :y="event.y + 3" text-anchor="middle" class="charting-engulfing-plot__event-label">{{ event.number }}</text>
        </g>
    </svg>
</template>

<style scoped>
.charting-engulfing-plot { display: block; width: 100%; }
.charting-engulfing-plot__month { fill: color-mix(in srgb, #8b5cf6 6%, transparent); }
.charting-engulfing-plot__caption { font: 600 9px sans-serif; fill: var(--p-text-muted-color); letter-spacing: 0.6px; }
.charting-engulfing-plot__grid { stroke: var(--charting-b-border-color); stroke-width: 0.5; }
.charting-engulfing-plot__guide { stroke: var(--p-text-muted-color); stroke-dasharray: 4 4; stroke-width: 0.8; }
.charting-engulfing-plot__price { font: 10px sans-serif; fill: var(--p-text-muted-color); }
.charting-engulfing-plot__event { fill: #7c3aed; }
.charting-engulfing-plot__event-label { font: 700 10px sans-serif; fill: white; }
</style>
